import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../providers/UserProvider";
import { auth, getRecipe, getUserDocument, updateRecipes } from "../firebase";
import Card from "./Card";


function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function formatSteps(unformatted: string) {

    const array = unformatted.replace('\']', "").replace('[\'', "").split("\', \'")
    const finalSteps = []
    const formatted = array.map((item: string, index: number) => {
      finalSteps.push((index + 1).toString() + ". " + capitalizeFirstLetter(item));
    });
    return finalSteps;
  
}

function formatIngredients(unformatted: string) {

    const array = unformatted.replace('\']', "").replace('[\'', "").split("\', \'")
    let finalString = ""
    const formatted = array.map((item: string, index: number) => {
      finalString = finalString.concat( item + ", ");
    });
    finalString = finalString.substring(0, finalString.length - 2)
    return finalString;
  
}

const ProfilePage = () => {
  const user = useContext(UserContext);
  const { displayName, email, uid, liked, disliked, allergies, dietaryPref } = user;

  const [recipes, setRecipes] = useState([]);

  const [likedCount, setLikedCount] = useState(0);

  const [dislikedCount, setDislikedCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      if (user.recipeIds && user.recipeIds.length) {
        const newArr = [];
        for (let i = 0; i < user.recipeIds.length; i++) {
          const recipe = await getRecipe(user.recipeIds[i]);
          newArr.push(recipe);
        }
        setRecipes(newArr);

      }
    }
    
    fetchData();

  }, [user, setRecipes]);

  useEffect(() => {

    if (likedCount + dislikedCount >= 10 ) {
      async function makeAPICall() {    

        const updatedUserInfo =  await getUserDocument(uid);

        let apiResponse = "";
          const url = "https://us-central1-graceful-splice-319504.cloudfunctions.net/fima-recommend";
          
          const data = {
            "allergies": allergies ? allergies : '[]',
            "preferences": dietaryPref.toString(),
            "liked": updatedUserInfo.liked.toString(),
            "disliked": updatedUserInfo.disliked.toString(),
            "user": "this-is-will",
            "test": "will-1251"
          };

          console.log(JSON.stringify(data));

          await fetch(url, {
              method: 'POST',
              headers: {
               // 'Content-Type': 'application/json',
                'Accept': '*'
              },
              body: JSON.stringify(data), 
            }).then(response => response.text()).then(json => {
              apiResponse = JSON.stringify(json);
            })
            .catch(error => console.error('Error:', error));

          const recipeIds = apiResponse.replace("\"", "").replace("\"", "").split(",");

          await updateRecipes(uid, recipeIds);
          setLikedCount(0);
          setDislikedCount(0);
        }
        makeAPICall();

    };

  }, [likedCount, dislikedCount, updateRecipes])

  return (
    <div className = "mx-auto w-11/12 md:w-2/4 py-8 px-4 md:px-8">
      <div className="flex border flex-col items-center md:flex-row md:items-start border-blue-400 px-3 py-4" style={{backgroundColor: "#FFFFFF"}}>
        <div className = "md:pl-4">
        <h2 className = "text-2xl font-semibold">{displayName}</h2>
        <h3 className = "italic">{email}</h3>
        </div>
      </div>
      {recipes.map(recipe => {
          return (
            <>
            <br/>
              <Card 
                likedCount = {likedCount}
                dislikedCount = {dislikedCount}
                setDislikedCount={setDislikedCount}
                setLikedCount={setLikedCount}
                recipe={{
                  minutes: recipe.minutes,
                  title: recipe.name ? capitalizeFirstLetter(recipe.name) : "", 
                  description: recipe.description, 
                  ingredientsNum: recipe.n_ingredients,
                  uid: uid,
                  liked: liked.indexOf(recipe.recipeId) > -1,
                  disliked: disliked.indexOf(recipe.recipeId) > -1,
                  id: recipe.recipeId,
                  steps: recipe.steps ? formatSteps(recipe.steps) : [],
                  ingredients:recipe.ingredients ? formatIngredients(recipe.ingredients) : ""
                }}
              />
            </>
          )
        }
      )}
      <button className = "w-full py-3 bg-red-600 mt-4 text-white" onClick = {() => {auth.signOut()}}>Sign out</button>
    </div>
  ) 
};

export default ProfilePage;


